<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="6" class="pb-0">
        <AutocompleteGrade
          v-model="grade"
          required
          dense
          outlined
          label="Khối"
          @change="gradeChanged"
        />
      </v-col>

      <v-col cols="6" class="pb-0">
        <AutocompleteClass
          v-model="classData"
          clear-icon="mdi-close"
          label="Lớp"
          outlined
          dense
          :filter="classsFilters"
          required
          class="required"
          :rules="[$rules.required]"
          @change="classChanged"
        />
      </v-col>

      <v-col cols="12" class="py-0">
        <div v-if="defaultTeacher && defaultTeacher.id">
          <p class="mb-2">Giáo viên mặc định sẽ được sử dụng:</p>
          <CardTeacherName v-if="defaultTeacher" :teacher="defaultTeacher" />
        </div>

        <div v-else>
          <AutocompleteTeacherCardMany
            ref="autoCompleteTeacherCardMany"
            v-model="selectedTeachers"
            label="Giáo viên chủ nhiệm"
            outlined
            dense
            class="required"
            :rules="[teachersRule]"
          />
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteTeacherCardMany from '@/components/basic/input/AutocompleteTeacherCardMany'
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import { map, get, isArray } from 'lodash'

export default {
  name: 'OwnClassTeacherNewFormMany',
  components: {
    AutocompleteGrade,
    AutocompleteClass,
    AutocompleteTeacherCardMany,
    CardTeacherName
  },
  props: {
    state: Boolean,
    defaultTeacher: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      grade: '',
      classData: null,
      selectedTeachers: [],
      rules: [
      ]
    }
  },
  computed: {
    classsFilters() {
      return { grade: get(this.grade, 'id'), type: 'coreCurriculum' }
    },

    teachersRule() {
      return value => {
        const selected = isArray(value) ? value : this.selectedTeachers
        if (!selected || selected.length === 0) {
          return 'Vui lòng chọn ít nhất 1 giáo viên'
        }

        if (!this.classData || !this.classData.headTeachers) return true

        const existingIds = map(this.classData.headTeachers, 'id').filter(Boolean)

        for (const t of selected) {
          if (t && t.id && existingIds.includes(t.id)) {
            return 'Giáo viên này đã được phân công chủ nhiệm cho lớp trên'
          }
        }
        return true
      }
    }
  },
  methods: {
    classChanged(classData) {
      this.grade = get(classData, 'grade')
    },
    getData() {
      if (this.defaultTeacher && this.defaultTeacher.id) {
        if (!this.$refs.form.validate()) return null
        return { classData: this.classData, teachers: [this.defaultTeacher] }
      }

      if (this.$refs.form.validate()) {
        const teachers = isArray(this.selectedTeachers) ? this.selectedTeachers : []
        return { classData: this.classData, teachers }
      }
      return null
    },
    resetData() {
      this.grade = ''
      this.classData = null
      this.selectedTeachers = []
    },
    gradeChanged(grade) {
      if (this.classData && grade && this.classData.grade.id !== grade.id) {
        this.classData = null
      }
      this.grade = grade
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  mounted() {
    this.$refs.form.reset()
  },
  watch: {
    state(state) {
      if (!state) {
        this.resetData()
        this.$refs.form.reset()
      }
    },
    classData: 'resetValidation',
    grade: 'resetValidation'
  }
}
</script>